import type { IPrepareData } from '@/types'

interface IAptosPrepareData {
  gasLimit: number
  gasPrice: {
    high: number
    medium: number
    low: number
  }
  maxGasAmount: number
  publicKey: string
  sequenceNumber: number
  isRegistered: boolean
}

export class AptosPrepareData implements IPrepareData {
  public gasPrice: {
    high: number
    medium: number
    low: number
  }
  public gasLimit: number
  public maxGasAmount: number
  public publicKey: string
  public sequenceNumber: number
  public isRegistered: boolean

  constructor(data: IAptosPrepareData) {
    this.gasLimit = data.gasLimit
    this.gasPrice = {
      high: data.gasPrice.high,
      medium: data.gasPrice.medium,
      low: data.gasPrice.low,
    }
    this.maxGasAmount = data.maxGasAmount
    this.publicKey = data.publicKey
    this.sequenceNumber = data.sequenceNumber
    this.isRegistered = data.isRegistered
  }
}
